import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import * as moment from "moment";
import { toast } from "react-toastify";

import personalInfo from "assets/images/Frame (1).png";
import addemploymentinfo from "apis/panel/employmentInformation/employmentinfo";
import ReusableFunction from "utils/reusablefunction";
import FileHandler from "apis/panel/fileHandler/fileHandler";
import EmployeeAPI from "apis/panel/employee/employee";

import Context from "context/context";
import Loader from "components/Loader";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteIcon from "@mui/icons-material/Delete";
import { InputAdornment, IconButton } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

const probationPeriods = {
  0: "Not Applicable",
  1: "1 Month",
  2: "2 Months",
  3: "3 Months",
  6: "6 Months",
  9: "9 Months",
  12: "12 Months"
};

const EditEmployementinfo = () => {
  const { state, dispatch } = useContext(Context);
  const params = useParams();
  const employeeId = params.id;
  const { fileUploadAPI, fileDownloadAPI } = FileHandler();
  const { handleFileInputReselect } = ReusableFunction();

  const [roleCode, setRoleCode] = useState(state.role.roleCode);
  const [previousExperience, setPreviousExperience] = useState([]);

  const {
    getAllRolesAPI,
    getAlldesignationAPI,
    getAlldepartmentAPI,
    getAllemployementtypeAPI,
    getAllworklocationAPI,
    getAllexperiencesAPI,
    getEmployementcreateAPI,
  } = addemploymentinfo();

  const { getPreviousExperiencesAPI, getEmployeeCodeAPI } = EmployeeAPI();

  const [employeeCode, setemployeeCode] = useState();
  const [rolename, setrolename] = useState();
  const [roleid, setroleid] = useState();
  const [roleoption, setroleoption] = useState([]);
  const [designationname, setdesignationname] = useState();
  const [designationid, setdesignationid] = useState();
  const [designationoption, setdesignationoption] = useState([]);
  const [departmentname, setdepartmentname] = useState();
  const [departmentid, setdepartmentid] = useState();
  const [departmentoption, setdepartmentoption] = useState([]);
  const [employementtypename, setemployementtypename] = useState();
  const [employementtypeid, setemployementtypeid] = useState();
  const [employementtypeoption, setemployementtypeoption] = useState([]);
  const [worklocationname, setworklocationname] = useState();
  const [worklocationid, setworklocationid] = useState();
  const [worklocationoption, setworklocationoption] = useState([]);
  const [experiencesname, setexperiencesname] = useState();
  const [experiencesid, setexperiencesid] = useState();
  const [experiencesoption, setexperiencesoption] = useState([]);
  const [status, setstatus] = useState("");
  const [statusvalue, setstatusvalue] = useState("");
  // const [uan, setuan] = useState("");
  const [dateOfJoining, setDateOfJoining] = useState("");
  const [probationPeriod, setProbationPeriod] = useState();
  const [probationEndDate, setProbationEndDate] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [experienceInMonths, setExperienceInMonths] = useState(0);
  const [overallExperienceInMonths, setOverallExperienceInMonths] = useState(0);
  const [priorExperience, setPriorExperience] = useState("");
  const [employee, setEmployee] = useState({});

  useEffect(() => {
    let employeeDatas = state.employeeData;
    console.log({employeeDatas})
    if (employeeDatas) {
      setroleid(employeeDatas?.roles?.roleId);
      setrolename(employeeDatas?.roles?.roleName);
      setdesignationid(employeeDatas?.designations?.designationId);
      setdesignationname(employeeDatas?.designations?.designationName);
      setdepartmentid(employeeDatas?.departments?.departmentId);
      setdepartmentname(employeeDatas?.departments?.departmentName);
      setstatus(employeeDatas?.status);
      if (employeeDatas?.status === null) {
        setstatusvalue("Active");
        setstatus(1);
      } else {
        setstatusvalue(employeeDatas?.status == 1 ? "Active" : "Inactive");
        setstatus(employeeDatas?.status);
      }
      setemployementtypeid(employeeDatas?.employmentTypes?.employmentTypeId);
      setemployementtypename(
        employeeDatas?.employmentTypes?.employmentTypeName
      );
      if (employeeDatas === null || employeeDatas?.dateOfJoining === null) {
        setDateOfJoining("");
      } else {
        setDateOfJoining(employeeDatas?.dateOfJoining);
      }
      setworklocationid(employeeDatas?.workLocations?.workLocationId);
      setworklocationname(employeeDatas?.workLocations?.workLocationName);
      setexperiencesid(employeeDatas?.experiences?.experienceId);
      setexperiencesname(employeeDatas?.experiences?.yearsOfExperience);
      // setuan(employeeDatas?.uan);
      setemployeeCode(employeeDatas?.employeeCode);
      setPriorExperience(employeeDatas?.priorExperience);
      console.log({pr:employeeDatas?.probationPeriodMonths})
      setProbationPeriod(employeeDatas?.probationPeriodMonths)
    }
  }, [state?.employeeData]);

  const handleGetrole = async () => {
    try {
      let res = await getAllRolesAPI();
      setroleoption(res?.data || []);
    } catch (err) {}
  };

  const [errorFields, setErrorFields] = useState({
    Rolename: false,
    Departmentname: false,
    designation: false,
    employementstatus: false,
    employeetype: false,
    dateofjoining: false,
    worklocation: false,
    experience: false,
    // uan: false,
    employeeid: false,
    priorExperience: false,
    probationPeriod: false
  });

  const handleGetdesignation = async () => {
    try {
      let res = await getAlldesignationAPI();
      setdesignationoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetdepartment = async () => {
    try {
      let res = await getAlldepartmentAPI();
      setdepartmentoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetemployementtype = async () => {
    try {
      let res = await getAllemployementtypeAPI();
      setemployementtypeoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetworklocation = async () => {
    try {
      let res = await getAllworklocationAPI();

      setworklocationoption(res?.data || []);
    } catch (err) {}
  };

  const handleGetexperiences = async () => {
    try {
      let res = await getAllexperiencesAPI();
      setexperiencesoption(res?.data || []);
    } catch (err) {}
  };

  const handlestatusChange = (e) => {
    setstatus(e.target.value);
  };

  // const handleuan = (e) => {
  //   setuan(e.target.value);
  // };

  useEffect(() => {
    handleGetrole();
    handleGetdesignation();
    handleGetdepartment();
    handleGetemployementtype();
    handleGetworklocation();
    handleGetexperiences();
  }, []);

  const handleroleChange = (e) => {
    const selectedrole = roleoption.find(
      (option) => option.roleName === e.target.value
    );
    setrolename(selectedrole.roleName); // Set the titleName
    setroleid(selectedrole.roleId); // Set the titleId
  };

  const handledesignationChange = (e) => {
    const selecteddesignation = designationoption.find(
      (option) => option.designationName === e.target.value
    );
    setdesignationname(selecteddesignation.designationName); // Set the titleName
    setdesignationid(selecteddesignation.designationId); // Set the titleId
  };

  const handledepartmentChange = (e) => {
    const selecteddepartment = departmentoption.find(
      (option) => option.departmentName === e.target.value
    );
    setdepartmentname(selecteddepartment.departmentName); // Set the titleName
    setdepartmentid(selecteddepartment.departmentId); // Set the titleId
  };

  const handleemployementtypeChange = (e) => {
    const selectemployementtypement = employementtypeoption.find(
      (option) => option.employmentTypeName === e.target.value
    );
    setemployementtypename(selectemployementtypement.employmentTypeName); // Set the titleName
    setemployementtypeid(selectemployementtypement.employmentTypeId); // Set the titleId
  };

  const handleworklocationChange = (e) => {
    const selectworklocationment = worklocationoption.find(
      (option) => option.workLocationName === e.target.value
    );
    setworklocationname(selectworklocationment.workLocationName); // Set the titleName
    setworklocationid(selectworklocationment.workLocationId); // Set the titleId
  };

  const handleexperiencesChange = (e) => {
    const selectexperiences = experiencesoption.find(
      (option) => option.yearsOfExperience === e.target.value
    );
    setexperiencesname(selectexperiences.yearsOfExperience); // Set the titleName
    setexperiencesid(selectexperiences.experienceId); // Set the titleId
  };

  const handleCreateemplyement = async (e) => {
    let prevExpError = false;
    let updatedArr = [];

    e.preventDefault();
    // Validate form fields
    const errors = {};
    if (roleCode === "R011") {
      if (!roleid) errors.Rolename = true;
      if (!designationid) errors.designation = true;
      if (!departmentid) errors.Departmentname = true;
      if (!status) errors.employementstatus = true;
      if (!employementtypeid) errors.employeetype = true;
      if (!dateOfJoining) errors.dateofjoining = true;
      if (!worklocationid) errors.worklocation = true;
      if (!employeeId) errors.employeeid = true;
      if(probationPeriod == undefined || probationPeriod == null) errors.probationPeriod = true;
    }

    if (roleCode !== "R011" || state?.employee?.employeeId === employeeId) {
      if (!priorExperience) errors.priorExperience = true;
    }

    setErrorFields(errors);

    if (prevExp?.length > 0) {
      for (let index = 0; index < prevExp?.length; index++) {
        const current = { ...prevExp[index] };

        if (!current?.companyName) {
          current.companyNameError = true;
          prevExpError = true;
        } else {
          delete current.companyNameError;
        }

        if (!current?.designation) {
          current.designationError = true;
          prevExpError = true;
        } else {
          delete current.designationError;
        }

        if (!current?.startDate) {
          current.startDateError = true;
          prevExpError = true;
        } else {
          delete current.startDateError;
        }
        if (!current?.endDate) {
          current.endDateError = true;
          prevExpError = true;
        } else {
          current.endDateError = false;
        }
        if (!current?.expLetterFilePath) {
          current.expLetterFilePathError = true;
          prevExpError = true;
        } else {
          current.expLetterFilePathError = false;
        }
        const updatedPrevExp = [
          ...prevExp.slice(0, index),
          current,
          ...prevExp.slice(index + 1),
        ];

        setPrevExp(updatedPrevExp);
        updatedArr = updatedPrevExp;
      }
    }
    if (Object.keys(errors).length > 0 || prevExpError) {
      return toast.error(
        "Please complete all required fields before proceeding.",
        {
          toastId: "empty-field-error",
        }
      );
    }
    let formattedPrevExp = [];

    const safeMomentFormat = (val) => {
      if (!val) return null;

      let dateObj = null;

      if (val instanceof Date && !isNaN(val)) {
        dateObj = val;
      } else if (val?.toDate) {
        // dayjs / moment
        dateObj = val.toDate();
      } else if (typeof val === "string" || typeof val === "number") {
        const parsed = new Date(val);
        if (!isNaN(parsed)) dateObj = parsed;
      }

      return dateObj ? moment(dateObj).format("YYYY-MM-DD") : null;
    };

    updatedArr?.map((u) => {
      formattedPrevExp = [
        ...formattedPrevExp,
        {
          ...u,
          startDate: safeMomentFormat(u.startDate),
          endDate: safeMomentFormat(u.endDate),
        },
      ];
    });

    // If no errors, proceed with form submission
    if (Object.keys(errors).length === 0) {
      setLoader2(true);
      const values = {
        employeeId: employeeId,
        roleId: roleid,
        designationId: designationid,
        departmentId: departmentid,
        status: status,
        employmentTypeId: employementtypeid,
        dateOfJoining: moment(dateOfJoining).format("YYYY-MM-DD"),
        workLocationId: worklocationid,
        currentExperience: experienceInMonths,
        totalExperience: overallExperienceInMonths,
        priorExperience: priorExperience,
        // experienceId: experiencesid,
        // uan: uan,
        prevExp: formattedPrevExp,
        probationPeriodMonths: probationPeriod,
        probationEndDate: probationEndDate? moment(probationEndDate).format("YYYY-MM-DD") : ""
      };

      const data = await getEmployementcreateAPI(values);
      if (data.status === "Ok") {
        setLoader2(false);
        return toast.success("Data Saved Successfully", {
          toast: "Data Saved Successfully",
        });
      } else {
        setLoader2(false);
        return toast.error("Error saving Data", { toast: "Error saving Data" });
      }
    }
  };

  const handleReset = () => {
    setroleid("");
    setdesignationid("");
    setdepartmentid("");
    setstatus("");
    setemployementtypeid("");
    setDateOfJoining("");
    setworklocationid("");
    setexperiencesid("");
    // setuan("");
  };

  const toggleEditMode = (event) => {
    event.stopPropagation();
    setIsEditMode(!isEditMode);
  };

  const handleFieldChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
    if (!isExpanded) {
      // Accordion is not expanded, reset edit mode
      setIsEditMode(false);
    }
  };

  const [prevExp, setPrevExp] = useState([]);

  const handleGetData = async (e) => {
    const values = {
      employeeId,
    };
    const data = await getPreviousExperiencesAPI(values);
    let prevExpData = data?.data?.previousExperiences;
    for (let index = 0; index < prevExpData?.length; index++) {
      const element = prevExpData[index];
      if (element.startDate) {
        element.startDate = new Date(element.startDate);
      }
      if (element.endDate) {
        element.endDate = new Date(element.endDate);
      }
    }
    setPrevExp(prevExpData);
  };

  const handleGetEmployeeCode = async (e) => {
    const values = {
      employeeId,
    };
    const res = await getEmployeeCodeAPI(values);
    const data = res?.data?.employee;
    setEmployee(data);
  };

  useEffect(() => {
    if (employeeId) {
      handleGetData();
      handleGetEmployeeCode();
    }
  }, [employeeId]);

  const getFilenameFromUrl = (url) => {
    if (url !== "" && url !== undefined && url !== null) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    } else {
      return "";
    }
  };

  const handleFileUpload = async (file) => {
    const allowedTypes = ["application/pdf"];

    if (!allowedTypes.includes(file?.type)) {
      toast.error("Only PDF files are allowed.", {
        toastId: "file-type-error",
      });
      return false;
    }

    const maxSize = 1024 * 1024 * 5;
    if (file.size > maxSize) {
      toast.error("File size exceeds the limit (5MB)", {
        toastId: "file-upload-maximum",
      });
      return false;
    }

    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let input = new FormData();
      input.append("type", "employee_documents");
      input.append("employeeId", employeeId);
      input.append("file", file);
      const res = await fileUploadAPI(input);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res?.data?.location) {
        return res?.data?.location;
      }
      return false;
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleFileChange = async (event, index) => {
    if (!employeeId) {
      toast.error(
        "Please create an employee account before uploading documents.",
        {
          toastId: "employeeid-error",
        }
      );
      return false;
    }

    const file = event.target.files[0];

    let newName = `${employee?.employeeCode}_${
      employee?.fullName
    }_Experience_Letter_${index + 1}`;

    newName = `${newName}.${file?.name?.split(".").pop()}`;
    const renamedFile = new File([file], newName, { type: file.type });

    const location = await handleFileUpload(renamedFile);
    if (location) {
      setPrevExp([
        ...prevExp.slice(0, index),
        {
          ...prevExp[index],
          expLetterFilePath: location,
        },
        ...prevExp.slice(index + 1),
      ]);
    }
  };

  const handleAddPreviousExperience = () => {
    let prevExpError = false;

    if (prevExp?.length > 0) {
      let arr = [];
      for (let index = 0; index < prevExp?.length; index++) {
        const current = { ...prevExp[index] };

        if (!current?.companyName) {
          current.companyNameError = true;
          prevExpError = true;
        } else {
          current.companyNameError = false;
        }

        if (!current?.designation) {
          current.designationError = true;
          prevExpError = true;
        } else {
          current.designationError = false;
        }

        if (!current?.startDate) {
          current.startDateError = true;
          prevExpError = true;
        } else {
          current.startDateError = false;
        }
        if (!current?.endDate) {
          current.endDateError = true;
          prevExpError = true;
        } else {
          current.endDateError = false;
        }
        if (!current?.expLetterFilePath) {
          current.expLetterFilePathError = true;
          prevExpError = true;
        } else {
          current.expLetterFilePathError = false;
        }
        arr = [...arr, current];
      }
      setPrevExp(arr);
    }

    if (prevExpError) {
      return toast.error(
        "Please complete all required fields before proceeding.",
        {
          toastId: "add-more-exp-error",
        }
      );
    }

    setPrevExp([
      ...prevExp,
      {
        employeeId: employeeId,
        companyName: "",
        designation: "",
        startDate: null,
        endDate: null,
        expLetterFilePath: "",
        expInMonths: 0,
      },
    ]);
  };

  const handleDelPrevExp = (index) => {
    if (index === 0) {
      setPriorExperience("");
    }
    setPrevExp([...prevExp.slice(0, index), ...prevExp.slice(index + 1)]);
  };

  const handleFileDownload = async (id) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      await fileDownloadAPI(id);
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    if (dateOfJoining) {
      const startDate = moment(dateOfJoining);
      const endDate = moment(new Date());
      if (
        startDate.isValid() &&
        endDate.isValid() &&
        startDate.isBefore(moment())
      ) {
        const monthDiff = endDate.diff(startDate, "months");
        setExperienceInMonths(monthDiff);
        let overallPrevExp = 0;
        prevExp?.map((px) => {
          overallPrevExp += px.expInMonths;
        });
        setOverallExperienceInMonths(overallPrevExp + monthDiff);
      } else {
        setExperienceInMonths(0);
        setOverallExperienceInMonths(0);
      }
    }
  }, [dateOfJoining, prevExp]);

useEffect(()=>{
  if(dateOfJoining && probationPeriod !== undefined && probationPeriod !== null){
  const date =  moment(dateOfJoining).add(parseInt(probationPeriod), 'months').toDate() 
  console.log({date})
  if(probationPeriod === 0){
  setProbationEndDate(null)
  }else{
  setProbationEndDate(date)
  }
  }
},[dateOfJoining,probationPeriod])

  return (
    <div>
      <Loader loading={loader2} />
      <Accordion
        sx={{ mt: 2, boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon className="Accordianicon" />}
          aria-controls="panel1-content"
          id="panel1-header"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            height: "70px",
          }}
        >
          <Box sx={{ pl: 3 }}>
            {" "}
            <img
              sx={{ pl: 3 }}
              className="personalInfo-logo"
              src={personalInfo}
              alt="info"
            />
          </Box>
          <Box className="acc-title" sx={{ pl: 3 }}>
            Employement Information
          </Box>
          <Box sx={{ ml: 40 }}>
            {expanded &&
              ((roleCode === "R001" &&
                state?.employee?.employeeId === employeeId) ||
                roleCode !== "R001") && (
                <button className="editButton" onClick={toggleEditMode}>
                  Edit
                  <Box sx={{ flexGrow: 1 }} />
                  {isEditMode}
                </button>
              )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 1 }}>
            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Employee ID <span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  id="firstName"
                  placeholder="Employee Id"
                  variant="outlined"
                  fullWidth
                  value={employeeCode}
                  disabled={true}
                />
                {errorFields.employeeid && (
                  <span className="error-msg">Employee Id is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Employee ID</Box>
                <Box className="editvalue">{employeeCode}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  {" "}
                  Role <span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="title-label"
                    id="title"
                    style={{ border: "1px solid #B2D4F8", color: "grey" }}
                    defaultValue=""
                    name="title"
                    value={rolename}
                    onChange={handleroleChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Role</MenuItem>
                    {roleoption.map((option) => (
                      <MenuItem key={option.id} value={option.roleName}>
                        {option.roleName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.rolename && (
                  <span className="error-msg">Role is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Role</Box>
                <Box className="editvalue">{rolename}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  {" "}
                  Designation <span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="title-label"
                    id="title"
                    style={{ border: "1px solid #B2D4F8", color: "grey" }}
                    defaultValue=""
                    name="title"
                    value={designationname}
                    onChange={handledesignationChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Designation </MenuItem>
                    {designationoption.map((option) => (
                      <MenuItem key={option.id} value={option.designationName}>
                        {option.designationName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.designation && (
                  <span className="error-msg">Designation is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Designation</Box>
                <Box className="editvalue">{designationname}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  {" "}
                  Department <span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="title-label"
                    id="title"
                    style={{ border: "1px solid #B2D4F8", color: "grey" }}
                    defaultValue=""
                    name="title"
                    value={departmentname}
                    onChange={handledepartmentChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Department </MenuItem>
                    {departmentoption.map((option) => (
                      <MenuItem key={option.id} value={option.departmentName}>
                        {option.departmentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.Departmentname && (
                  <span className="error-msg">Department is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Department</Box>
                <Box className="editvalue">{departmentname}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  {" "}
                  Employement Status <span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="marital-status-label"
                    id="maritalStatus"
                    placeholder="Select Employement Status"
                    name="title"
                    defaultValue=""
                    value={status}
                    onChange={handlestatusChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Status</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
                {errorFields.employementstatus && (
                  <span className="error-msg">
                    Employment Status is required
                  </span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Employement Status</Box>
                <Box className="editvalue">{status}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Employement Type<span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="marital-status-label"
                    id="maritalStatus"
                    placeholder="Select Employement Type"
                    defaultValue=""
                    displayEmpty
                    value={employementtypename}
                    onChange={handleemployementtypeChange}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Type </MenuItem>
                    {employementtypeoption.map((option) => (
                      <MenuItem
                        key={option.id}
                        value={option.employmentTypeName}
                      >
                        {option.employmentTypeName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.employeetype && (
                  <span className="error-msg">
                    Employement Type is required
                  </span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Employement Type</Box>
                <Box className="editvalue">{employementtypename}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 1 }}>
                <Box className="label">
                  Date of Joining <span style={{ color: "red" }}>*</span>
                </Box>
                <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={dateOfJoining ? new Date(dateOfJoining) : ""}
                    onChange={(date) => {
                      setDateOfJoining(date);
                      // const startDate = moment(date);
                      // const endDate = moment(new Date());
                      // if (
                      //   startDate.isValid() &&
                      //   endDate.isValid() &&
                      //   startDate.isBefore(moment())
                      // ) {
                      //   const monthDiff = endDate.diff(startDate, "months");
                      //   setExperienceInMonths(monthDiff);
                      // }
                    }}
                    slotProps={{
                      field: { clearable: true },
                    }}
                    format="dd/MM/yyyy"
                    maxDate={moment().add(1, "months").toDate()}
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                    disabled={roleCode !== "R011"}
                  />
                </LocalizationProvider>
                {errorFields.dateofjoining && (
                  <span className="error-msg">Date of Joining is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Date of Joining</Box>
                <Box className="editvalue">
                  {dateOfJoining
                    ? moment(dateOfJoining).format("DD/MM/YYYY")
                    : ""}
                </Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 1 }}>
                <Box className="label">
                  Work Location<span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="marital-status-label"
                    id="maritalStatus"
                    placeholder="Select Work Location"
                    defaultValue=""
                    value={worklocationname}
                    onChange={handleworklocationChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                    disabled={roleCode !== "R011"}
                  >
                    <MenuItem value=""> Select Location </MenuItem>
                    {worklocationoption.map((option) => (
                      <MenuItem key={option.id} value={option.workLocationName}>
                        {option.workLocationName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.worklocation && (
                  <span className="error-msg">Work Location is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Work Location</Box>
                <Box className="editvalue">{worklocationname}</Box>
              </Grid>
            )}

              {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Probation Period<span style={{ color: "red" }}>*</span>
                </Box>
                <FormControl fullWidth>
                  <Select
                    labelId="probation-period-label"
                    id="probation-period"
                    placeholder="Select Probation Period"
                    defaultValue=""
                    displayEmpty
                    value={probationPeriod}
                    onChange={(e)=>{
                      setProbationPeriod(parseInt(e.target.value))
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                    style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                    disabled={roleCode !== "R011"}
                  >
                    {Object.keys(probationPeriods)?.map((key) => (
                      <MenuItem
                        key={probationPeriods[key]}
                        value={key}
                      >
                        {probationPeriods[key]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errorFields.probationPeriod && (
                  <span className="error-msg">
                    Probation Period is required
                  </span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">Probation Period</Box>
                <Box className="editvalue">{probationPeriod? probationPeriod < 2 ? probationPeriod  + " " + "Month":probationPeriod  + " " + "Months":"-"}</Box>
              </Grid>
            )}

               {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                 Probation End Date
                </Box>
               <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={probationEndDate ?? null}
                    format="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField {...params} helperText={null} />
                    )}
                    disabled={true}
                  />
                </LocalizationProvider>
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">
                  Probation End Date
                </Box>
                <Box className="editvalue">{probationEndDate?moment(probationEndDate).format("DD/MM/YYYY"):"-"}</Box>
              </Grid>
            )}

            {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  Current Experience in ValueHealth (Months)
                </Box>
                <TextField
                  id="experience-in-valuehealth"
                  variant="outlined"
                  fullWidth
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: 100 } }}
                  disabled={true}
                  value={experienceInMonths || 0}
                />
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">
                  Current Experience in ValueHealth (Months)
                </Box>
                <Box className="editvalue">{experienceInMonths}</Box>
              </Grid>
            )}

            {roleCode !== "R001" &&
              (isEditMode ? (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Box className="label" style={{ color: "black" }}>
                    Total Year of Employment Experience (Months)
                  </Box>
                  <TextField
                    id="overall-experience-in-valuehealth"
                    variant="outlined"
                    fullWidth
                    type="number"
                    InputProps={{ inputProps: { min: 0, max: 100 } }}
                    disabled={true}
                    value={overallExperienceInMonths || 0}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                  <Box className="editlabel" style={{ color: "black" }}>
                    Total Year of Employment Experience (Months)
                  </Box>
                  <Box className="editvalue">{overallExperienceInMonths}</Box>
                </Grid>
              ))}

            {/* {isEditMode ? (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box className="label">
                  UAN<span style={{ color: "red" }}>*</span>
                </Box>
                <TextField
                  id="firstName"
                  placeholder="Enter UAN"
                  variant="outlined"
                  fullWidth
                  onChange={handleuan}
                  value={uan}
                />
                {errorFields.uan && (
                  <span className="error-msg">uan is required</span>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                <Box className="editlabel">UAN</Box>
                <Box className="editvalue">{uan}</Box>
              </Grid>
            )} */}

            {((roleCode === "R001" &&
              state?.employee?.employeeId === employeeId) ||
              roleCode !== "R001") &&
              (isEditMode ? (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Box className="label">
                    Do you have any previous experience?
                    {(roleCode !== "R011" || state?.employee?.employeeId === employeeId) &&<span style={{ color: "red" }}>*</span>}
                  </Box>
                  <FormControl fullWidth>
                    <Select
                      labelId="prior-experience"
                      id="prior-experience"
                      defaultValue=""
                      value={priorExperience}
                      onChange={(e) => {
                        setPriorExperience(e.target.value);
                        if (e.target.value === "Yes") {
                          handleAddPreviousExperience();
                        } else {
                          setPrevExp([]);
                        }
                      }}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                    >
                      {["Yes", "No"].map((option) => (
                        <MenuItem key={option.id} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorFields.priorExperience && (
                    <span className="error-msg">
                      Prior Experience is required
                    </span>
                  )}
                </Grid>
              ) : (
                <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                  <Box className="editlabel">Previous Experience</Box>
                  <Box className="editvalue">{priorExperience}</Box>
                </Grid>
              ))}
          </Grid>

          {isEditMode && prevExp?.length > 0 && (
            <Grid container spacing={0} className="prev-exp-parent">
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  className="prev-exp-btn"
                  onClick={handleAddPreviousExperience}
                >
                  Add More Experience
                </Button>
              </Grid>
            </Grid>
          )}

          {((roleCode === "R001" &&
            state?.employee?.employeeId === employeeId) ||
            roleCode !== "R001") &&
            prevExp?.map((section, index) => (
              <div key={index}>
                <hr
                  style={{
                    margin: "20px 30px",
                    border: "none",
                    height: "1px",
                    backgroundColor: "rgb(128 128 128 / 32%)",
                  }}
                />
                <Grid container spacing={2} sx={{ pl: 3, pr: 5, mt: 3, mb: 1 }}>
                  <Box
                    className="subHeadingforinfos"
                    sx={{ pl: 3 }}
                    style={{ alignSelf: "center" }}
                  >
                    Previous Experience - {index + 1}
                  </Box>
                  {isEditMode && (
                    <button
                      className="prev-exp-rem-btn"
                      onClick={() => {
                        handleDelPrevExp(index);
                      }}
                    >
                      Remove
                    </button>
                  )}
                </Grid>
                <Grid container spacing={2} sx={{ pl: 4, pr: 5 }}>
                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Company Name<span style={{ color: "red" }}>*</span>
                      </Box>
                      <TextField
                        id="firstName"
                        placeholder="Enter Company Name"
                        variant="outlined"
                        fullWidth
                        value={prevExp[index]?.companyName || ""}
                        onChange={(e) => {
                          setPrevExp([
                            ...prevExp.slice(0, index),
                            {
                              ...prevExp[index],
                              companyName: e.target.value,
                            },
                            ...prevExp.slice(index + 1),
                          ]);
                        }}
                      />
                      {prevExp[index]?.companyNameError && (
                        <span className="error-msg">
                          Company Name is required
                        </span>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">Company Name</Box>
                      <Box className="editvalue">
                        {prevExp[index]?.companyName || "-"}
                      </Box>
                    </Grid>
                  )}
                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Designation<span style={{ color: "red" }}>*</span>
                      </Box>
                      <TextField
                        id="firstName"
                        placeholder="Enter Designation"
                        variant="outlined"
                        fullWidth
                        value={prevExp[index]?.designation || ""}
                        onChange={(e) => {
                          setPrevExp([
                            ...prevExp.slice(0, index),
                            {
                              ...prevExp[index],
                              designation: e.target.value,
                            },
                            ...prevExp.slice(index + 1),
                          ]);
                        }}
                      />
                      {prevExp[index]?.designationError && (
                        <span className="error-msg">
                          Designation is required
                        </span>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">Designation</Box>
                      <Box className="editvalue">
                        {prevExp[index]?.designation || "-"}
                      </Box>
                    </Grid>
                  )}
                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Start Date<span style={{ color: "red" }}>*</span>
                      </Box>
                      <LocalizationProvider
                        fullWidth
                        dateAdapter={AdapterDateFns}
                      >
                        <DatePicker
                          sx={{ width: "100%" }}
                          fullWidth
                          value={prevExp[index]?.startDate || null}
                          onChange={(date) => {
                            let monthDiff;

                            let updateObj = {
                              startDate: date,
                            };

                            if (date === null) {
                              updateObj = {
                                startDate: null,
                                expInMonths: null,
                              };
                            } else {
                              const startDate = moment(date);
                              const endDate = moment(prevExp[index]?.endDate);
                              if (startDate.isValid() && endDate.isValid()) {
                                monthDiff = endDate.diff(startDate, "months");
                                updateObj = {
                                  ...updateObj,
                                  expInMonths: monthDiff,
                                };
                              }
                            }

                            setPrevExp([
                              ...prevExp.slice(0, index),
                              { ...prevExp[index], ...updateObj },
                              ...prevExp.slice(index + 1),
                            ]);
                          }}
                          slotProps={{
                            field: { clearable: true },
                          }}
                          maxDate={
                            moment(dateOfJoining)
                              .subtract(1, "days")
                              .toDate() || new Date()
                          }
                          disabled={!dateOfJoining}
                        />
                      </LocalizationProvider>

                      {prevExp[index]?.startDateError && (
                        <span className="error-msg">
                          Start Date is required
                        </span>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">Start Date</Box>
                      <Box className="editvalue">
                        {moment(prevExp[index]?.startDate).format(
                          "DD/MM/YYYY"
                        ) || "-"}
                      </Box>
                    </Grid>
                  )}

                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        End Date<span style={{ color: "red" }}>*</span>
                      </Box>
                      <LocalizationProvider
                        fullWidth
                        dateAdapter={AdapterDateFns}
                      >
                        <DatePicker
                          sx={{ width: "100%" }}
                          fullWidth
                          value={prevExp[index]?.endDate || null}
                          onChange={(date) => {
                            let monthDiff;
                            let updateObj = { endDate: date };

                            if (date === null) {
                              updateObj = { endDate: null, expInMonths: null };
                            } else {
                              const startDate = moment(
                                prevExp[index]?.startDate
                              );
                              const endDate = moment(date);

                              if (startDate.isValid() && endDate.isValid()) {
                                monthDiff = endDate.diff(startDate, "months");
                                updateObj = {
                                  ...updateObj,
                                  expInMonths: monthDiff,
                                };
                              }
                            }

                            setPrevExp([
                              ...prevExp.slice(0, index),
                              { ...prevExp[index], ...updateObj },
                              ...prevExp.slice(index + 1),
                            ]);
                          }}
                          slotProps={{
                            field: { clearable: true },
                          }}
                          minDate={prevExp[index]?.startDate || null}
                          maxDate={
                            moment(dateOfJoining)
                              .subtract(1, "days")
                              .toDate() || new Date()
                          }
                          disabled={!prevExp[index]?.startDate}
                        />
                      </LocalizationProvider>
                      {prevExp[index]?.endDateError && (
                        <span className="error-msg">End Date is required</span>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">End Date</Box>
                      <Box className="editvalue">
                        {moment(prevExp[index]?.endDate).format("DD/MM/YYYY") ||
                          "-"}
                      </Box>
                    </Grid>
                  )}

                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Experience Letter (PDF){" "}
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <TextField
                        className="editvalue"
                        fullWidth
                        placeholder="Browse Files (max of 5mb) "
                        value={getFilenameFromUrl(
                          prevExp[index]?.expLetterFilePath
                        )}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {prevExp[index]?.expLetterFilePath && (
                                <IconButton
                                  onClick={() => {
                                    setPrevExp([
                                      ...prevExp.slice(0, index),
                                      {
                                        ...prevExp[index],
                                        expLetterFilePath: null,
                                      },
                                      ...prevExp.slice(index + 1),
                                    ]);
                                  }}
                                  edge="end"
                                  aria-label="clear file"
                                >
                                  <ClearIcon />
                                </IconButton>
                              )}
                              <input
                                type="file"
                                accept=".pdf"
                                id={`experience-letter-${index}`}
                                style={{ display: "none" }}
                                onClick={handleFileInputReselect}
                                onChange={(e) => {
                                  handleFileChange(e, index);
                                }}
                              />
                              <label htmlFor={`experience-letter-${index}`}>
                                <IconButton
                                  component="span"
                                  color="primary"
                                  aria-label="attach file"
                                >
                                  <AttachFileIcon
                                    style={{ color: "#0056B2" }}
                                  />
                                </IconButton>
                              </label>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {prevExp[index]?.expLetterFilePathError && (
                        <span className="error-msg">
                          Experience Letter is required
                        </span>
                      )}
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">Experience Letter (PDF)</Box>
                      {prevExp[index]?.expLetterFilePath ? (
                        <span
                          onClick={() => {
                            handleFileDownload(
                              prevExp[index]?.expLetterFilePath
                            );
                          }}
                          className="download"
                        >
                          <DownloadForOfflineIcon
                            style={{ fontSize: 30, verticalAlign: "middle" }}
                          />{" "}
                          {"Click to download"}
                        </span>
                      ) : (
                        <Box className="editvalue"> -</Box>
                      )}
                    </Grid>
                  )}

                  {isEditMode ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">Experience (Months)</Box>
                      <TextField
                        id="experience"
                        variant="outlined"
                        fullWidth
                        type="number"
                        InputProps={{ inputProps: { min: 0, max: 100 } }}
                        disabled={true}
                        value={prevExp[index]?.expInMonths || 0}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel">Experience (Months)</Box>
                      <Box className="editvalue">
                        {prevExp[index]?.expInMonths || 0}
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </div>
            ))}

          {isEditMode && (
            <Grid
              container
              spacing={1}
              sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }}
            >
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button className="cancelButton" onClick={toggleEditMode}>
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={12} sm={2} md={2} lg={2}>
                <Button className="saveButton" onClick={handleCreateemplyement}>
                  Save
                </Button>
              </Grid>
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default EditEmployementinfo;
